import type { AgentSessionEntry } from './api';
import { diskActivityAt } from './sessionRecency';

/**
 * Choose the session to show after a row is deleted.
 *
 * Keeps active-session deletes from leaving the UI pointed at a transcript
 * that no longer exists. The fallback mirrors the sidebar sort order: the
 * most recently active remaining session wins, otherwise the panel opens a
 * fresh session.
 */
export function nextSessionIdAfterDelete(sessions: AgentSessionEntry[], deletedSessionId: string): string | null {
  const [next] = sessions
    .filter((session) => session.session_id !== deletedSessionId)
    .sort((left, right) => diskActivityAt(right) - diskActivityAt(left));
  return next?.session_id ?? null;
}
